let config = {
    // secretKey: '5LPcaHvMb1DAmNrbXCbBVZMs6dttd8TA',
    // secretId: 'AKIDCDDI9d5Whf3aAdwurZy2kUyrV3B8EF5f',
    secretKey: 'f8RaYKzfMvKXYNyOiqjbIk14sXG1f8Te',
    secretId: 'AKIDeKtHVcijXBc6UrGj5ISjvueMyaFtMrH1',
    appId: 1301325388,
}
window.config = config

